import React from 'react';
import { Row, Input, CustomInput } from "reactstrap";
import Button from "@material-ui/core/Button";
import { getJudgementData, postJudgementData } from "./EntryofJudgementNotice.actions";
import { connect } from 'react-redux'
import { remove } from "lodash";
import { useState,useEffect } from "react";


import { isEmpty } from "lodash";

const EntryofJudgementNotice = (props) => {

    useEffect(() => {
        props.getJudgementData();
    }, []);

    function clickFunction() {
        props.postJudgementData({

            divorce_id: window.localStorage.getItem("divorce_id"),
            form190NoticEntryJudgmentId: Boxes,
        });
    }
    const [Boxes, setBoxes] = useState([]);

    function getCheckedValue(value) {
        if (Boxes.includes(value)) {
            let dummyArray = Boxes;
            remove(dummyArray, function (val) {
                return val === value;
            });
        } else {
            let dummyArray = Boxes;
            dummyArray.push(value);
            setBoxes(dummyArray);
        }
    }

    return (
        <div style={{ background: "white", height: "540px", paddingLeft: "20px", marginLeft: "10px" }}>

             {!isEmpty(props.array) &&  props.array.map((item, i) => (
                        <Row style={{ paddingLeft: "30px", paddingTop: "10px", fontFamily: "notoserif", fontStyle: "italic" }}>
                        <CustomInput type="checkbox" id={item.form_190_notic_entry_judgment_id} onChange={(e) => getCheckedValue(e.target.id)} label={item.notic_entry_judgment_description} /> 
                        </Row>
                    
                    ))}
         
            <Row style={{ paddingTop: "10px", paddingLeft: "10px", width: "400px" }}>
                <Input id="text" type="textarea" onBlur={(e) => getCheckedValue(e.target.value)} />
            </Row>
            <Row style={{ paddingTop: "25px", paddingLeft: "15px" }}>
                <Button variant="contained" color="primary" id="submit" onClick={() => { clickFunction() }} >
                    Submit
            </Button>
            </Row>
        </div>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        getJudgementData: () => dispatch(getJudgementData()),
        postJudgementData: (data) => dispatch(postJudgementData(data))
    }
}

const mapStateToProps = (state, ownProps) => ({
    array: state.EntryofJudgementNoticeReducer.array,

})

export default connect(mapStateToProps, mapDispatchToProps)(EntryofJudgementNotice);
